export default __webpack_public_path__ + "static/dacha-camera-1-40e6ad05b71f23ad580023955ea4b5c6.png";